import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { convertToPath, Path } from '@antv/g';
import { copyAttributes } from '../utils/helper';
import { attributeKeys, attributeOf } from './utils';
function localBBoxOf(shape) {
  var _shape$getLocalBounds = shape.getLocalBounds(),
    min = _shape$getLocalBounds.min,
    max = _shape$getLocalBounds.max;
  var _min = _slicedToArray(min, 2),
    x0 = _min[0],
    y0 = _min[1];
  var _max = _slicedToArray(max, 2),
    x1 = _max[0],
    y1 = _max[1];
  var height = y1 - y0;
  var width = x1 - x0;
  return [x0, y0, width, height];
}
function d(bbox) {
  var _bbox = _slicedToArray(bbox, 4),
    x = _bbox[0],
    y = _bbox[1],
    width = _bbox[2],
    height = _bbox[3];
  return "\n    M ".concat(x, " ").concat(y, "\n    L ").concat(x + width, " ").concat(y, "\n    L ").concat(x + width, " ").concat(y + height, "\n    L ").concat(x, " ").concat(y + height, "\n    Z\n  ");
}
function pack(shape, count) {
  var _localBBoxOf = localBBoxOf(shape),
    _localBBoxOf2 = _slicedToArray(_localBBoxOf, 4),
    x0 = _localBBoxOf2[0],
    y0 = _localBBoxOf2[1],
    width = _localBBoxOf2[2],
    height = _localBBoxOf2[3];
  var aspect = height / width;
  var col = Math.ceil(Math.sqrt(count / aspect));
  var row = Math.ceil(count / col);
  var B = [];
  var h = height / row;
  var j = 0;
  var n = count;
  while (n > 0) {
    var c = Math.min(n, col);
    var w = width / c;
    for (var i = 0; i < c; i++) {
      var x = x0 + i * w;
      var y = y0 + j * h;
      B.push(d([x, y, w, h]));
    }
    n -= c;
    j += 1;
  }
  return B;
}
function normalizeSplit() {
  var split = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pack';
  if (typeof split == 'function') return split;
  return pack;
}
/**
 * Translate and scale.
 */
function shapeToShape(from, to, timeEffect) {
  var _localBBoxOf3 = localBBoxOf(from),
    _localBBoxOf4 = _slicedToArray(_localBBoxOf3, 4),
    x0 = _localBBoxOf4[0],
    y0 = _localBBoxOf4[1],
    w0 = _localBBoxOf4[2],
    h0 = _localBBoxOf4[3];
  var fromTransform = from.style.transform;
  var toTransform = to.style.transform; // Replace first to get right bbox after mounting.
  replaceChild(to, from);
  // Apply translate and scale transform.
  var _localBBoxOf5 = localBBoxOf(to),
    _localBBoxOf6 = _slicedToArray(_localBBoxOf5, 4),
    x1 = _localBBoxOf6[0],
    y1 = _localBBoxOf6[1],
    w1 = _localBBoxOf6[2],
    h1 = _localBBoxOf6[3];
  var dx = x0 - x1;
  var dy = y0 - y1;
  var sx = w0 / w1;
  var sy = h0 / h1;
  var keyframes = [Object.assign({
    transform: "".concat(fromTransform ? fromTransform + ' ' : '', "translate(").concat(dx, ", ").concat(dy, ") scale(").concat(sx, ", ").concat(sy, ")")
  }, attributeOf(from, attributeKeys)), Object.assign({
    transform: "".concat(toTransform ? toTransform + ' ' : '', "translate(0, 0) scale(1, 1)")
  }, attributeOf(to, attributeKeys))];
  var animation = to.animate(keyframes, timeEffect);
  return animation;
}
/**
 * Replace object and copy className and __data__
 */
function replaceChild(newChild, oldChild) {
  newChild['__data__'] = oldChild['__data__'];
  newChild.className = oldChild.className;
  // @ts-ignore
  newChild.markType = oldChild.markType;
  oldChild.parentNode.replaceChild(newChild, oldChild);
}
/**
 * Replace element with a path shape.
 */
function maybePath(node, d) {
  var nodeName = node.nodeName;
  if (nodeName === 'path') return node;
  var path = new Path({
    style: Object.assign(Object.assign({}, attributeOf(node, attributeKeys)), {
      d: d
    })
  });
  replaceChild(path, node);
  return path;
}
function hasUniqueString(search, pattern) {
  var first = search.indexOf(pattern);
  var last = search.lastIndexOf(pattern);
  return first === last;
}
// Path definition with multiple m and M command has sub path.
// eg. 'M10,10...M20,20', 'm10,10...m20,20'
function hasSubPath(path) {
  return !hasUniqueString(path, 'm') || !hasUniqueString(path, 'M');
}
function shape2path(shape) {
  var path = convertToPath(shape);
  if (!path) return;
  // Path definition with sub path can't do path morphing animation,
  // so skip this kind of path.
  if (hasSubPath(path)) return;
  return path;
}
function oneToOne(shape, from, to, timeEffect) {
  // If the nodeTypes of from and to are equal,
  // or non of them can convert to path,
  // the apply shape to shape animation.
  var fromName = from.nodeName;
  var toName = to.nodeName;
  var fromPath = shape2path(from);
  var toPath = shape2path(to);
  var isSameNodes = fromName === toName && fromName !== 'path';
  var hasNonPathNode = fromPath === undefined || toPath === undefined;
  if (isSameNodes || hasNonPathNode) return shapeToShape(from, to, timeEffect);
  var pathShape = maybePath(shape, fromPath);
  // Convert Path will take transform, anchor, etc into account,
  // so there is no need to specify these attributes in keyframes.
  var keyframes = [Object.assign({
    path: fromPath
  }, attributeOf(from, attributeKeys)), Object.assign({
    path: toPath
  }, attributeOf(to, attributeKeys))];
  var animation = pathShape.animate(keyframes, timeEffect);
  animation.onfinish = function () {
    pathShape.style.transform = 'none';
    copyAttributes(pathShape, to);
  };
  // Remove transform because it already applied in path
  // converted by convertToPath.
  pathShape.style.transform = 'none';
  return animation;
}
function oneToMultiple(from, to, timeEffect, split) {
  // Hide the shape to be split before being removing.
  from.style.visibility = 'hidden';
  var D = split(from, to.length);
  return to.map(function (shape, i) {
    var path = new Path({
      style: Object.assign({
        path: D[i]
      }, attributeOf(from, attributeKeys))
    });
    return oneToOne(shape, path, shape, timeEffect);
  });
}
function multipleToOne(from, to, timeEffect, split) {
  var D = split(to, from.length);
  var _to$style = to.style,
    _to$style$fillOpacity = _to$style.fillOpacity,
    fillOpacity = _to$style$fillOpacity === void 0 ? 1 : _to$style$fillOpacity,
    _to$style$strokeOpaci = _to$style.strokeOpacity,
    strokeOpacity = _to$style$strokeOpaci === void 0 ? 1 : _to$style$strokeOpaci,
    _to$style$opacity = _to$style.opacity,
    opacity = _to$style$opacity === void 0 ? 1 : _to$style$opacity;
  var keyframes = [{
    fillOpacity: 0,
    strokeOpacity: 0,
    opacity: 0
  }, {
    fillOpacity: 0,
    strokeOpacity: 0,
    opacity: 0,
    offset: 0.99
  }, {
    fillOpacity: fillOpacity,
    strokeOpacity: strokeOpacity,
    opacity: opacity
  }];
  var animation = to.animate(keyframes, timeEffect);
  var animations = from.map(function (shape, i) {
    var path = new Path({
      style: {
        path: D[i],
        fill: to.style.fill
      }
    });
    return oneToOne(shape, shape, path, timeEffect);
  });
  return [].concat(_toConsumableArray(animations), [animation]);
}
/**
 * Morphing animations.
 * @todo Support more split function.
 */
export var Morphing = function Morphing(options) {
  return function (from, to, defaults) {
    var split = normalizeSplit(options.split);
    var timeEffect = Object.assign(Object.assign({}, defaults), options);
    var fl = from.length;
    var tl = to.length;
    if (fl === 1 && tl === 1 || fl > 1 && tl > 1) {
      var _from = _slicedToArray(from, 1),
        f = _from[0];
      var _to = _slicedToArray(to, 1),
        t = _to[0];
      return oneToOne(f, f, t, timeEffect);
    }
    if (fl === 1 && tl > 1) {
      var _from2 = _slicedToArray(from, 1),
        _f = _from2[0];
      return oneToMultiple(_f, to, timeEffect, split);
    }
    if (fl > 1 && tl === 1) {
      var _to2 = _slicedToArray(to, 1),
        _t = _to2[0];
      return multipleToOne(from, _t, timeEffect, split);
    }
    return null;
  };
};
Morphing.props = {};